export default __webpack_public_path__ + "ce5dda6b629398a600a1b55ab2b867e1.png";